import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "button-link-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppTooltip = _resolveComponent("AppTooltip")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button-link", { 'with-icon': _ctx.hasIcon }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
    onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseEnter && _ctx.handleMouseEnter(...args))),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
  }, [
    (_ctx.iconSrc)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.iconSrc,
          width: "16",
          height: "16",
          class: "button-link-icon"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
    (_ctx.showTooltip && _ctx.tooltipText)
      ? (_openBlock(), _createBlock(_component_AppTooltip, {
          key: 1,
          text: _ctx.tooltipText,
          width: _ctx.tooltipWidth
        }, null, 8, ["text", "width"]))
      : _createCommentVNode("", true)
  ], 34))
}